import { Box, Checkbox, SvgIcon } from "@mui/material";
import React, { useState } from "react";

const CustomChecked = (props) => (
	<SvgIcon viewBox="0 0 24 24" {...props}>
		<path d="M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z" fill="#06757F" />
		<path fillRule="evenodd" clipRule="evenodd" d="M19.7099 5.79C19.5222 5.60069 19.2666 5.4942 18.9999 5.4942C18.7333 5.4942 18.4777 5.60069 18.2899 5.79L7.99994 16.09L4.70994 12.79C4.31782 12.3979 3.68206 12.3979 3.28994 12.79C2.89782 13.1821 2.89782 13.8179 3.28994 14.21L7.28994 18.21C7.47771 18.3993 7.7333 18.5058 7.99994 18.5058C8.26658 18.5058 8.52217 18.3993 8.70994 18.21L19.7099 7.21C19.8993 7.02223 20.0057 6.76664 20.0057 6.5C20.0057 6.23336 19.8993 5.97777 19.7099 5.79Z" fill="white" />
	</SvgIcon>
);
const CustomUnchecked = (props) => (<SvgIcon viewBox="0 0 24 24" {...props}>
	<mask id="path-1-inside-1_8300_312" fill="white">
		<path d="M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z" />
	</mask>
	<path d="M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z" fill="white" />
	<path d="M4 0V2H20V0V-2H4V0ZM24 4H22V20H24H26V4H24ZM20 24V22H4V24V26H20V24ZM0 20H2V4H0H-2V20H0ZM4 24V22C2.89543 22 2 21.1046 2 20H0H-2C-2 23.3137 0.686292 26 4 26V24ZM24 20H22C22 21.1046 21.1046 22 20 22V24V26C23.3137 26 26 23.3137 26 20H24ZM20 0V2C21.1046 2 22 2.89543 22 4H24H26C26 0.686291 23.3137 -2 20 -2V0ZM4 0V-2C0.686291 -2 -2 0.686292 -2 4H0H2C2 2.89543 2.89543 2 4 2V0Z" fill="#626366" mask="url(#path-1-inside-1_8300_312)" />
</SvgIcon>
);

const TaskStatusSelector = ({ currentStatus, taskStatuses, setNextStatus }) => {

	const [statusCheckbox, setStatusCheckbox] = useState([]);

	const getNextStatus = () => {
		if (currentStatus && taskStatuses.length) {
			const status = taskStatuses.find(s => s.id == currentStatus).code;
			if (status == 'PLAN' || status == 'PACK') {
				return [taskStatuses.find(s => s.code == 'HEAD')];
			}

			if (status == 'HEAD') {
				return [taskStatuses.find(s => s.code == 'ARVD')];
			}

			if (status == 'ARVD') {
				return [
					taskStatuses.find(s => s.code == 'RECY'),
					taskStatuses.find(s => s.code == 'COMP')
				];
			}

			if (status == 'RECY') {
				return [taskStatuses.find(s => s.code == 'COMP')];
			}
		} else {
			return null;
		}
	}

	const nextStatus = getNextStatus();

	return (
		<>
			{nextStatus?.length && nextStatus?.map((s, index) => (
				<Box
					key={`box-${index}`}
					sx={{
						border: 2,
						borderRadius: '8px',
						borderColor: '#DCDDDE',
						color: '#2B2929',
						fontFamily: 'New Transport',
						height: '72px',
						fontSize: '16px',
						display: 'flex',
						flexDirection: 'row',
						width: '100%',
						pl: '15px',
						pr: '20px',
						verticalAlign: 'middle',
						alignItems: 'center',
						mb: '8px'
					}}
				>
					<Box key={`box2-${index}`}>
						<Checkbox
							checked={Boolean(statusCheckbox[index])}
							icon={<CustomUnchecked />}
							checkedIcon={<CustomChecked />}
							key={`checkbox-${index}`}
							sx={{
								width: '24px',
								height: '24px',
								mr: '15px'
							}}
							onChange={(e) => {
								setStatusCheckbox(prev => {
									const next = [...prev];
									next[index] = e.target.checked;
									return next;
								})
								if (e.target.checked) {
									setNextStatus(s.id);
								} else {
									setNextStatus(currentStatus);
								}
							}}
						/>
					</Box>
					<Box key={`box3-${index}`}>
						Mark as {s.code}
					</Box>
				</Box>
			))}
		</>
	);
}

export default TaskStatusSelector;